// The seven Ontario TRANSFERABLE SKILLS (the store carries look-fors for
// exactly these seven). Self-Regulation is a LEARNING SKILL, not a
// transferable skill — it has no look-fors in the store, so it must never
// appear in a transferable-skill selector (a teacher picking it would have
// nothing to draw from). It lives on its own /strategies playbook page.
export const SKILL_FOCUS_OPTIONS = [
  "Critical Thinking & Problem Solving",
  "Collaboration",
  "Communication",
  "Self-Directed Learning",
  "Innovation, Creativity & Entrepreneurship",
  "Global Citizenship & Sustainability",
  "Digital Literacy",
];

// Tier 2 #4 — one-line descriptor for each transferable skill so the
// picker teaches what choosing that skill DOES to the generated lesson,
// rather than asking the teacher to guess.
export const SKILL_FOCUS_DESCRIPTORS = {
  "Critical Thinking & Problem Solving":
    "Adds reasoning prompts and 'how do you know?' questioning",
  "Collaboration":
    "Structures partner roles and shared accountability",
  "Communication":
    "Builds in explain-your-thinking moments and audience-aware tasks",
  "Self-Directed Learning":
    "Adds goal-setting, choice points, and a self-monitoring step",
  "Innovation, Creativity & Entrepreneurship":
    "Opens an open-ended make/design phase with multiple valid solutions",
  "Global Citizenship & Sustainability":
    "Anchors the task in real-world community, equity, or environmental context",
  "Digital Literacy":
    "Layers in source evaluation, digital tools, and information hygiene",
};

// Tier 2 #4 — sentinel option teachers can pick when they want the
// system to choose the best-fit transferable skill for their grade +
// subject combination. Backend treats this sentinel value specially.
export const SKILL_FOCUS_AUTO = "Let Atomic Edu choose";

// Atomic Edu serves Ontario Grades 4–8 (Phase 105.4). Curriculum
// expectation data + scope-and-sequence pacing files only exist for
// 4–8, so the UI selectors should not offer Grade 1/2/3.
export const GRADE_OPTIONS = ["Grade 4", "Grade 5", "Grade 6", "Grade 7", "Grade 8"];

export const SUBJECT_OPTIONS = [
  "Language",
  "Mathematics",
  "Science & Technology",
  "Social Studies",
  "History",
  "Geography",
  "The Arts",
  "Health & Physical Education",
  "French as a Second Language",
];

export const TIME_OPTIONS = [
  "20 minutes",
  "30 minutes",
  "40 minutes",
  "50 minutes",
  "60 minutes",
  "75 minutes",
];

export const ACTIVITY_TYPE_OPTIONS = [
  "Warm-up / Bell Ringer",
  "Small Group Discussion",
  "Hands-on / Maker",
  "Independent Practice",
  "Inquiry / Investigation",
  "Reflection / Journaling",
  "Game-based",
  "Performance / Presentation",
  "Exit Ticket",
];
